var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-5 my-5"},[_c('slider',{key:_vm.current,attrs:{"current":_vm.current,"questions":_vm.questions,"answers":_vm.answers,"results":_vm.brands},on:{"update:current":function($event){_vm.current=$event},"updated":_vm.updateAnswer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d4603ec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/survey/Survey.vue
// module id = 388
// module chunks = 0